
import React, { memo, useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { selectNumberingDatalist } from '../Selectors/TrackSelector/TrackSelector';
import { fetchNumberingList, InsertNumberingInwardEntry } from '../../Store/PHPSlice/Numbering/numberingApi';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import axios from 'axios';

const NumberingIssueReturn = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        id: Id,
        dt: getCurrentDate(),
        empNm: '',
        empId: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [usedTotMtr, setUsedTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const [baleNo, setBaleNo] = useState('');
    const [inwardData, setInwardData] = useState([]);

    const [loading, setLoading] = useState(false);
    const [soMaterial, setSoMaterial] = useState([]);
    const clIssInfo = useSelector(selectNumberingDatalist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchNumberingList(Id));
        fetchMaterialProductionList(Id);
    }, [Id, dispatch]);


    // console.log(formData);
    useEffect(() => {
        if (clIssInfo?.data && clIssInfo.data.length > 0) {
            const item = clIssInfo.data[0];
            // console.log(item)
            const inwMemo = clIssInfo.countId > 0 ? `R-${item.numMemo}-${parseFloat(clIssInfo.countId) + 1}` : `R-${item.numMemo}-1`;

            setFormData(prev => ({
                ...prev,
                memo: inwMemo,
                numMemo: item?.numMemo,
                ctInwId: item?.ctInwId,
                sono: item?.sono,
                ctMemo: item?.ctMemo,
                empType: item?.empType,
                empNm: item?.empNm,
                empId: item?.empId,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                clothNm: item?.clothNm,
                m1Cloth: item?.m1Cloth,
                m2Cloth: item?.m2Cloth,
                m3Cloth: item?.m3Cloth,
                cutTotQty: item?.cutTotQty,
                numIssQty: item?.numIssQty,
                reQty: item?.reQty,
                sts: item?.sts
            }));
        }
        if (clIssInfo.numberingInfo.length > 0) {
            //setInwardData(clIssInfo.numberingInfo);
            setInwardData(
                clIssInfo.numberingInfo.map(item => ({
                    ...item,
                    inwardQty: item.inwardQty || 0,
                    extraQty: item.extraQty || 0,
                    damageQty: item.damageQty || 0
                }))
            );
        }
    }, [clIssInfo]);
const handleExtraChange = (index, e) => {
    const value = parseInt(e.target.value || 0);

    const updated = inwardData.map((item, i) => {
        if (i === index) {

            const inward = parseInt(item.inwardQty || 0);
            const damage = parseInt(item.damageQty || 0);

            const remaining = calculateRemaining(item.gQty, inward, value, damage);

            return {
                ...item,
                extraQty: value,
                bqty: remaining
            };
        }
        return item;
    });

    setInwardData(updated);
};

  const handleDamageChange = (index, e) => {
    const value = parseInt(e.target.value || 0);

    const updated = inwardData.map((item, i) => {
        if (i === index) {

            const inward = parseInt(item.inwardQty || 0);
            const extra = parseInt(item.extraQty || 0);

            const remaining = calculateRemaining(item.gQty, inward, extra, value);

            return {
                ...item,
                damageQty: value,
                bqty: remaining
            };
        }
        return item;
    });

    setInwardData(updated);
};

    useEffect(() => {
        if (inwardData) {
            const updatedMat = [...soMaterial];
            const calculated = updatedMat?.map(item => {
                const rows = item?.info.row?.map((it, vidx) => {
                    const qty = parseFloat(inwardData[vidx].inwardQty || 0);
                    {/* const qty = 0; */ }
                    const matgqty = parseFloat(it.matgqty);
                    const matsize = parseFloat(it.matsize);
                    const perpktqty = parseFloat(item.perpktqty);

                    let issqty = 0;
                    let issmtr = 0;
                    let issInch = 0;
                    let issmqty = 0;

                    switch (item.mtype) {
                        case "Pcs":
                            issqty = ((parseFloat(matgqty) * qty) / perpktqty).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        case "Mtr":
                            issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                            issInch = (issmtr * 39.3701).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        case "Inch":
                            {/* issInch = matgqty * qty; */ }
                            issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                            issmtr = (issInch / 39.3701).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        default:
                            break;
                    }

                    return {
                        ...it,
                        issqty,
                        issmtr,
                        issInch,
                        issmqty
                    };
                });

                const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);

                return {
                    ...item,
                    reoutmtr: totissmtr.toFixed(2),   // 👈 THIS is the key
                    reoutinch: totissInch.toFixed(2),
                    reoutqty: totissqty.toFixed(2),
                    reoutTotqty: totissmqty
                };
            });
            setSoMaterial(calculated);
        }
    }, [inwardData]);

    const fetchMaterialProductionList = async (id) => {
        const departNm = "NUMBERING";
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialProduction_Issuedata_departNm_prodid&departNm=${departNm}&prod_id=${id}`)
            // console.log(res.data);
            setSoMaterial(res.data?.data || []);
        } catch (error) {
            console.error('error', error);
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    // const handleQtyChange = (index, e) => {
    //     const value = parseInt(e.target.value || 0, 10);
    //     const updated = inwardData.map((item, i) =>
    //         i === index ? {
    //             ...item,
    //             inwardQty: value <= item.bQty ? value : item.inwardQty,
    //             bqty: value <= item.bQty ? item.bQty - value : item.bqty
    //         } : item
    //     );

    //     if (value <= inwardData[index].bQty) {
    //         setInwardData(updated);
    //     } else {
    //         alert("Inward Qty cannot be greater than Remaining Qty.");
    //     }


    // };
    const calculateRemaining = (gQty, inward, extra, damage) => {
    const remaining = gQty - inward + extra - damage;
    return remaining >= 0 ? remaining : 0;
};
    const handleQtyChange = (index, e) => {
    const value = parseInt(e.target.value || 0);

    const updated = inwardData.map((item, i) => {
        if (i === index) {

            const extra = parseInt(item.extraQty || 0);
            const damage = parseInt(item.damageQty || 0);

            const remaining = calculateRemaining(item.gQty, value, extra, damage);

            return {
                ...item,
                inwardQty: value,
                bqty: remaining
            };
        }
        return item;
    });

    setInwardData(updated);
};
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const totalInwardQty = inwardData?.reduce((sum, item) => {
                return sum + parseFloat(item.inwardQty || 0);
            }, 0);

            const payload = {
                id: formData?.id,
                dt: formData.dt,
                numInwMemo: formData.memo,
                numMemo: formData.numMemo,
                numIssQty: formData.numIssQty,
                totInwQty: totalInwardQty,
                empId: formData.empId,
                userId: formData.userId,
                inwardInfo: inwardData.map(item => ({
                    size: item.size,
                    issQty: item.gQty,
                    balQty: item.bQty,
                    inwardQty: item.inwardQty || 0,
                    extraQty: item.extraQty || 0,
    damageQty: item.damageQty || 0
                })),
                materialData: soMaterial
            };
            // console.log("Submitting:", payload);
            const result = await dispatch(InsertNumberingInwardEntry(payload)).unwrap();

            console.log('POST request successful!', result);
            // alert("Numbering inward added successfully");
            // 
            if (result.status === "success") {
                alert(result.msg);
                window.opener.postMessage("REFRESH_PARENT", "*");
                window.close();
            } else {
                alert(result.msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const fields = [
        { name: 'dt', type: 'date' }
    ];

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    }





    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Numbering Issue Return</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }}>
                                        {/* <input
                                            type="date"
                                            value={new Date().toISOString().split('T')[0]}
                                            max={new Date().toISOString().split('T')[0]}
                                            style={{ width: '100%' }}
                                        /> */}
                                        {fields.map((field) => (
                                            <DateInputComponent
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                            />
                                        ))}
                                    </td>
                                    <td style={{ width: '200px' }}>Inward Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.memo}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Numbering Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.numMemo}</td>
                                    <td style={{ width: '200px' }}>Cutting Return No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.ctMemo}</td>
                                </tr>

                                {formData.ctInwId !== '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>SO No.</td>

                                        <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.sono}</td>
                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.clothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1Cloth || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2Cloth || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3Cloth || '-'}</td>
                                </tr>
                            </tbody>

                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #0a0a0a' }} align='center'>Total Cutting Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Issue Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Remaining Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Extra  Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Damage  Qty.</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(inwardData) && inwardData.length > 0 ? (
                                        inwardData.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.ctQty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.gQty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.bqty}</TableCell>
                                                <TableCell
                                                    key={index}
                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                    align='center'
                                                >
                                                    <input
                                                        type="text"
                                                        value={item.inwardQty || 0}
                                                        onChange={(e) => handleQtyChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>
                                                <TableCell  key={index}
                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                    <input
                                                        type="number"
                                                        value={item.extraQty || 0}
                                                        onChange={(e) => handleExtraChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>

                                                <TableCell  key={index}
                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                    <input
                                                        type="number"
                                                        value={item.damageQty || 0}
                                                        onChange={(e) => handleDamageChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                        </TableContainer>


                        {soMaterial.length > 0 &&
                            <div style={{ marginLeft: '5%' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Material Name</th>
                                            <th>Size</th>
                                            {soMaterial?.[0].info?.row.map(i => (
                                                <th key={i.size}>{i.size}</th>
                                            ))}
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {soMaterial.map((item, index) => {
                                            const rows = item?.info.row?.map((it, vidx) => {
                                                //const qty = parseFloat(inwardData?.[vidx]?.inwardQty || 0);
                                                const inward = parseFloat(inwardData?.[vidx]?.inwardQty || 0);
                                                const extra = parseFloat(inwardData?.[vidx]?.extraQty || 0);
                                                const damage = parseFloat(inwardData?.[vidx]?.damageQty || 0);

                                                const qty = inward + extra - damage;
                                                {/* const qty = 0; */ }
                                                const matgqty = parseFloat(it.matgqty);
                                                const matsize = parseFloat(it.matsize);

                                                let issqty = 0;
                                                let issmtr = 0;
                                                let issInch = 0;
                                                let issmqty = 0;

                                                switch (item.mtype) {
                                                    case "Pcs":
                                                        issqty = parseFloat(matgqty) * qty;
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    case "Mtr":
                                                        issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                                        issInch = (issmtr * 39.3701).toFixed(2);
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    case "Inch":
                                                        {/* issInch = matgqty * qty; */ }
                                                        issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                                        issmtr = (issInch / 39.3701).toFixed(2);
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    default:
                                                        break;
                                                }

                                                return {
                                                    ...it,
                                                    issqty,
                                                    issmtr,
                                                    issInch,
                                                    issmqty
                                                };
                                            });
                                            const mtype = item.mtype;

                                            {/* const totitemqty = qtyArr.reduce((acc, sum) => acc + parseFloat(sum || 0), 0); */ }
                                            const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                                            const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                                            const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                                            const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td rowSpan={6}>
                                                            {item.materialNm}
                                                            <br />
                                                            <small>({item.mtype})</small>

                                                        </td>
                                                        <td>Material Length</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.matsize}</td>
                                                        ))}
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>Per Size M. Qty.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.matgqty}</td>
                                                        ))}
                                                        <td></td>
                                                    </tr>
                                                    {/* style={{ fontWeight: 800, background: '#fccfa1' }} */}
                                                    <tr>
                                                        <td>Qty.</td>
                                                        {inwardData.map((q, i) => (
                                                            <td key={i}>{q.inwardQty}</td>
                                                        ))}
                                                        {/* <td><b>{totitemqty}</b></td> */}
                                                        <td></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#fdd4d4' }}>
                                                        <td>Mtr.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issmtr}</td>
                                                        ))}
                                                        <td><b>{totissmtr}</b></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#85e07c' }}>
                                                        <td>Inch.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issInch}</td>
                                                        ))}
                                                        <td><b>{totissInch}</b></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#b4b4f7' }}>
                                                        <td>Total Qty.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issmqty}</td>
                                                        ))}
                                                        <td><b>{totissmqty}</b></td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tbody>

                                </table>


                                <table>
                                    <thead>
                                        <th>Sr.No.</th>
                                        <th>Barcode</th>
                                        <th>Material</th>
                                        <th>M type</th>
                                        <th>Issue P Qty.</th>
                                        <th>Return P Qty.</th>
                                        <th>Issue Mtr</th>
                                        <th>Return Mtr</th>
                                        <th>Issue Inch</th>
                                        <th>Return Inch</th>
                                        <th>Issue Totqty</th>
                                        <th>Return Totqty</th>
                                    </thead>
                                    <tbody>
                                        {soMaterial?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {index + 1}</td>
                                                <td>{item.barcode}</td>
                                                <td>{item.materialNm}</td>
                                                <td>{item.mtype}</td>
                                                <td>{item.outqty}</td>
                                                <td>{item.reoutqty}</td>
                                                <td>{item.outMtr}</td>
                                                <td>{item.reoutmtr}</td>
                                                <td>{item.outInch}</td>
                                                <td>{item.reoutinch}</td>
                                                <td>{item.outBoxQty}</td>
                                                <td>{item.reoutTotqty}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        }



                        <Grid item xs={12} textAlign="center">
                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                {
                                    loading === true ?
                                        <><CircularProgress size="20px" /> wait...</> :
                                        "Submit"
                                }
                            </Button>
                        </Grid>
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default NumberingIssueReturn;
